import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import MinimumStockForm from '@/components/Reports/StockReports/MinimumStockForm';
import { DefaultRouteTabs } from '@/components/_common';
import { FormatType } from '@/core/domain/reports/movements/dailyMovement/dailyMovement.types';
import { useGenerateMinimumStockReport } from '@/core/domain/reports/stock/Report.hooks';
import {
  ReportMinimumStockParams,
  StockMinimumFilterBy,
  StockMinimumFormValues,
  StockMinimumTypes,
} from '@/core/domain/reports/stock/Report.types';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { useReportHandlers } from '@/hooks/useReportHandler';
import { PageProps } from '@/types/PageProps';
import { Divider, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

const MinimumStockPage = ({ route }: PageProps) => {
  const [form] = Form.useForm<StockMinimumFormValues>();
  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const generateReport = useGenerateMinimumStockReport();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const values = await form.validateFields();

      let filterIds = '';

      if (
        values.filterBy === StockMinimumFilterBy.manufacturing &&
        values.manufacturerIds?.length
      ) {
        filterIds = values.manufacturerIds.toString();
      }

      if (
        (values.filterBy === StockMinimumFilterBy.group,
        values.groupIds?.length)
      ) {
        filterIds = values.groupIds.toString();
      }

      if (
        values.filterBy === StockMinimumFilterBy.subGroup &&
        values.subGroupsIds?.length
      ) {
        filterIds = values.subGroupsIds.toString();
      }

      const obj: ReportMinimumStockParams = {
        ...values,
        companiesIds: values.companiesIds.toString(),
        filterIds,
        format: format === FormatType.CSV ? FormatType.CSV : FormatType.PDF,
        isConsumable: values.type.includes(StockMinimumTypes.consumable),
        isPart: values.type.includes(StockMinimumTypes.part),
        minimumStock: values.minimumStock,
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatorio_estoque_minimo',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={useIntl().formatMessage({ id: route.name })} />
      <MinimumStockForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
};

export default MinimumStockPage;
